import axios from 'axios';

export function adminApproveCampaignContent(adId, token) {
    return axios.post(
        `${process.env.REACT_APP_API_URL}/admin/advertisements/${adId}/approve-content`,
        {},
        {
            headers: {
                Authorization: `${token}`,
            },
        }
    );
}
